/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Assistant_ResizeInputs */



/**
* | output |
* | --- |
* | "Resize AI Assistant panel" |
*
* @param {Assistant_ResizeInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const assistant_resize = /** @type {((inputs?: Assistant_ResizeInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Assistant_ResizeInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Redimensionner le panneau de l'assistant IA")
	if (locale === "de") return /** @type {LocalizedString} */ ("Größe des KI-Assistenten-Panels ändern")
	if (locale === "it") return /** @type {LocalizedString} */ ("Ridimensiona il pannello dell'Assistente AI")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Панель «Изменение размера» с помощью ИИ")
	if (locale === "es") return /** @type {LocalizedString} */ ("Cambiar el tamaño del panel del Asistente de IA")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("调整 AI 助手面板大小")
	if (locale === "ja") return /** @type {LocalizedString} */ ("AIアシスタントパネルのサイズ変更")
	if (locale === "hi") return /** @type {LocalizedString} */ ("एआई असिस्टेंट पैनल का आकार बदलें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Redimensionar painel do Assistente de IA")
	return /** @type {LocalizedString} */ ("Resize AI Assistant panel")
});